import React from 'react';
import {observer} from "mobx-react";

const ALLOWED_TYPES = [
    {value: 'Wall', label: 'Walls'},
    {value: 'Floor', label: 'Floor'},
    {value: 'CribMattress', label: 'Crib sheet'},
    {value: 'CribBlanket', label: 'Crib hanging blanket'},
    {value: 'ToddlerBedMattress', label: 'Toddler bed sheet'},
    {value: 'ToddlerBedBlanket', label: 'Toddler bed blanket'},
    {value: 'TwinBedMattress', label: 'Twin bed sheet'},
    {value: 'TwinBedBlanket', label: 'Twin bed blanket'},
    {value: 'QueenBedMattress', label: 'Queen bed sheet'},
    {value: 'QueenBedBlanket', label: 'Queen bed blanket'},
    {value: 'BassinetMattress', label: 'Bassinet sheet'},
    {value: 'BassinetBlanket', label: 'Bassinet blanket'},
];

@observer
export class TextureVariantSpecific extends React.Component {
    componentDidMount() {
        if (!this.props.variant.typeSpecific.allowedType) {
            this.props.onChange('allowedType', ALLOWED_TYPES[0].value);
            this.props.onChange('specularColor', '000000');
        }
    }

    render() {
        const {variant, onChange} = this.props;

        return (
            <div className="colspan type-specific">
                <label htmlFor={`allowedType-${variant.id}`}>Can be dropped on:</label>
                <select id={`allowedType-${variant.id}`} value={variant.typeSpecific.allowedType}
                        onChange={({target}) => onChange('allowedType', target.value)}>
                    {ALLOWED_TYPES.map(type => (
                        <option value={type.value} key={type.id}>{type.label}</option>))}
                </select>

                <label htmlFor={`specularColor-${variant.id}`}>Specular (shine)</label>
                <input type="text" onChange={({target}) => onChange('specularColor', target.value)}
                       id={`specularColor-${variant.id}`}
                       placeholder="RGB"
                       value={variant.typeSpecific.specularColor}/>

                <label htmlFor={`repeat-${variant.id}`}>Repeat?</label>
                <input type="checkbox" onChange={({target}) => onChange('repeat', target.checked)}
                       id={`repeat-${variant.id}`} checked={variant.typeSpecific.repeat}/>

                <label htmlFor={`uSize-${variant.id}`}>Width:</label>
                <input type="number" step="0.1" onChange={({target}) => onChange('uSize', target.value)}
                       id={`uSize-${variant.id}`}
                       value={variant.typeSpecific.uSize} placeholder='Tile size in inches'/>

                <label htmlFor={`vSize-${variant.id}`}>Height:</label>
                <input type="number" step="0.1" onChange={({target}) => onChange('vSize', target.value)}
                       id={`vSize-${variant.id}`}
                       value={variant.typeSpecific.vSize} placeholder='Tile size in inches'/>
            </div>);
    }
}

